<script lang="ts">
	import Tooltip from '../../../../../atoms/Tooltip.svelte'
	import IconMailSent from '$svg/icon-mail-sent-successful.svg?component'
	import IconMailSentFailed from '$svg/icon-mail-sent-failed.svg?component'
	import { TooltipPlacements } from '$types/enums'
	import { t } from '$i18n/i18n'
	import { appState } from '$mapapp/stores/appstate.svelte'
	import type { PlatformRequestMailInfo } from '$mapapp/data/data.model'
	import { fetchUtils } from '$utils/fetchUtils'

	interface Props {
		popId: string
		lotId?: string // Only used for the legacy map.
		refreshToken?: number // Only used for the legacy map.
	}

	let { popId, lotId, refreshToken }: Props = $props()

	let text: string | null = $state(null)
	let toolTipText: string = $state('')
	let isRequested: boolean = $state(true)
	let tooltipOffset: [number, number] = $state([-9, 10])

	let Icon = $derived(isRequested ? IconMailSent : IconMailSentFailed)

	function getPlatformRequestMailInfo() {
		// If lotId is present, we are in legacy mode on the old map and cannot use appState.
		// Remove when the old legacy map has been removed.
		if (lotId) {
			fetchUtils
				.get(`/api/platformRequest/lastMailInfos/${lotId}/${popId}`, false)
				.then(setData)
				.catch((err) => {
					console.error('failed to fetch mail infos', err.message)
				})
			return
		}

		appState.matching?.getPartnerMailInfo(popId).then(setData)
	}

	function setData(mailInfo: PlatformRequestMailInfo | undefined) {
		if (mailInfo) {
			isRequested = mailInfo.isRequested
			toolTipText = mailInfo.toolTipText
			text = $t(`UI.PlatformRequest.mailInfo.${isRequested ? 'requested' : 'open'}`)
			if (mailInfo.toolTipText.includes('<br>')) {
				tooltipOffset = [-19, 10]
			}
		}
	}

	$effect(() => {
		void [refreshToken]
		getPlatformRequestMailInfo()
	})
</script>

{#if text}
	<Tooltip
		msg={toolTipText}
		placementTtip={TooltipPlacements.RIGHT}
		offsetTtip={tooltipOffset}
		ttipIconImage=""
		isHtml
	>
		<span class:isRequested class="platform-request-mail-info">
			<span>{text}</span>
			<Icon width="20px" height="20px" fill="inherit" />
		</span>
	</Tooltip>
{/if}

<style lang="scss">
	@use '$styles/global';

	.platform-request-mail-info {
		text-align: center;
		display: inline-flex;
		align-items: center;
		column-gap: 4px;
		white-space: nowrap;
		min-height: 24px;
		margin-top: 0.2rem;
		padding: 1px 5px;
		border-radius: 4px;
		color: var(--color-gray-400);
		background-color: var(--color-gray-50);
		fill: var(--color-gray-400);

		span {
			@include global.roboto-font(20px, 500, 12px, var(--color-gray-400));
		}
	}

	.isRequested {
		background-color: var(--color-highlight-green-100);
		text-align: center;
		fill: var(--color-green-500);

		span {
			color: var(--color-green-500);
		}
	}
</style>
